export interface Tag {
  id?: string; // offline created Tags don't have an id
  fullPath: string; // e.g.: 'wedding/services/catering'
  color?: string;
  isArchived?: boolean;
  plannedExpenditure?: number;
  plannedIncome?: number;
  actualExpenditure?: number;
  actualIncome?: number;
  runningBalance?: number;
  summary?: Summary | null;
  isPeriodic?: boolean;
  periods?: TagPeriod[];
}

export interface TagPeriod {
  period: Period;
  plannedIncome?: number;
  plannedExpenditure?: number;
  actualIncome?: number; // this is not saved in firebase
  actualExpenditure?: number; // this is not saved in firebase
  isHidden?: boolean;
}

export interface Period {
  year: number;
  month: number;
}

export enum Summary {
  runningBalance = 'runningBalance',
  expenditureProgress = 'expenditureProgress',
  incomeProgress = 'incomeProgress',
  none = 'none',
}
